// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

var Types = {};

var fragmentConverter = {"__root":{"images_edges_node":{"f":""}}};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

var Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

var Utils = {};

var node = ((function(){
var v0 = {
  "kind": "Variable",
  "name": "ratio",
  "variableName": "__relay_internal__pv__DevicePixelRatio"
},
v1 = {
  "kind": "Literal",
  "name": "width",
  "value": 1200
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__DevicePixelRatio"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ConversationMessageImages_conversationMessage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ConversationMessageImageConnection",
      "kind": "LinkedField",
      "name": "images",
      "plural": false,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "alias": null,
            "args": null,
            "concreteType": "ConversationMessageImageEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ImageAttachment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ConversationMessageImages_OneOfSeveralImages_image"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ConversationMessageImages_SingleImage_image"
                  },
                  {
                    "alias": "carouselFullscreen",
                    "args": [
                      (v0/*: any*/),
                      (v1/*: any*/)
                    ],
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  },
                  {
                    "alias": "carouselLarge",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "height",
                        "value": 800
                      },
                      (v0/*: any*/),
                      (v1/*: any*/)
                    ],
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  },
                  {
                    "alias": "carouselSmall",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "embed",
                        "value": true
                      },
                      {
                        "kind": "Literal",
                        "name": "height",
                        "value": 500
                      },
                      (v0/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "width",
                        "value": 750
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  },
                  {
                    "alias": "carouselThumb",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "crop",
                        "value": true
                      },
                      {
                        "kind": "Literal",
                        "name": "height",
                        "value": 90
                      },
                      (v0/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "width",
                        "value": 90
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          "action": "NONE"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ConversationMessageV5",
  "abstractKey": null
};
})());

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
